import type { CSSSettings, PSDLayer } from "shared-types";
import hexToRgb from "shared-utils/utils/hexToRgb";

export default function setLayerSettings(layer: PSDLayer, settings: CSSSettings) {
    return {
        ...layer,
        ...(settings.visible !== undefined && { visible: settings.visible }),
        bounds: {
            ...layer.bounds,
            ...(settings.top !== undefined && { top: settings.top }),
            ...(settings.left !== undefined && { left: settings.left }),
            ...(settings.width !== undefined && { width: settings.width }),
            ...(settings.height !== undefined && { height: settings.height }),
        },
        ...(layer?.text && {
            text: {
                ...layer.text,
                characterStyles: layer.text.characterStyles?.map((style) => ({
                    ...style,
                    ...(settings.fontSize && { fontSize: settings.fontSize }),
                    ...(settings.lineHeight && { lineHeight: settings.lineHeight }),
                    ...(settings.letterSpacing && { letterSpacing: settings.letterSpacing }),
                    ...(settings.fontWeight && { fontWeight: settings.fontWeight }),
                    ...(settings.fontStyle && { fontStyle: settings.fontStyle }),
                    ...(settings.fontColor && {
                        fontColor: { rgb: hexToRgb(settings.fontColor, true) },
                    }),
                    ...(settings.fontFamily && {
                        fontFamily: {
                            url: settings.fontFamily.signedUrl,
                            ...(settings.fontFamily.postScriptName && {
                                name: settings.fontFamily.postScriptName,
                            }),
                        },
                    }),
                })),
                paragraphStyles: layer.text.paragraphStyles.map((style) => ({
                    ...style,
                    ...(settings.textAlignment && { alignment: settings.textAlignment }),
                })),
            },
        }),
    };
}
